export default __webpack_public_path__ + "static/media/beanz-logo.svg";